import { render, staticRenderFns } from "./app-list.vue?vue&type=template&id=4829a54e&scoped=true"
import script from "./app-list.vue?vue&type=script&lang=js"
export * from "./app-list.vue?vue&type=script&lang=js"
import style0 from "./app-list.scss?vue&type=style&index=0&id=4829a54e&prod&lang=scss&scoped=true&external"
import style1 from "./app-list.vue?vue&type=style&index=1&id=4829a54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4829a54e",
  null
  
)

export default component.exports